const SELECTORS = {
  revealPopup: 'show-discount-modal',
  revealValue: 'true',
  modal: '.custom-modal',
  container: '.custom-modal__container',
  closeButton: '.custom-modal__button',
  hidden: 'hidden',
  show: 'show',
  hide: 'hide-modal',
  discountInfo: '.discount-info',
  discountInfoActive: 'active',
  sessionStorageKey: 'ba-discounted-plan-name',
  discountedPlanElement: '.discounted-plan-name',
  variantToSelect: '[data-js-product-variant-container] [value="{{value}}"]',
  variantToSelectKey: 'ba-discounted-variant-name',
}

function closeModal(modal) {
  modal.classList.remove(SELECTORS.show);
  modal.classList.add(SELECTORS.hide);
}

const modals = document.querySelectorAll(SELECTORS.modal);
const discountText = sessionStorage.getItem(SELECTORS.sessionStorageKey);
const variantToSelectName = sessionStorage.getItem(SELECTORS.variantToSelectKey);

const timeout = theme.modal_timeout || 1000;

// Set variant connected to discount if possible
if (variantToSelectName) {
  setTimeout(() => {
    document.querySelector(SELECTORS.variantToSelect.replace('{{value}}', variantToSelectName))?.click();
  }, timeout);
}

modals.forEach((modal) => {
  const container = modal.querySelector(SELECTORS.container);
  const closeButton = modal.querySelector(SELECTORS.closeButton);
  const discountedPlanElement = modal.querySelector(SELECTORS.discountedPlanElement);

  if (closeButton) {
    closeButton.addEventListener('click', () => {
      closeModal(container);
    });
  }
  
  if (discountText && discountedPlanElement) {
    discountedPlanElement.classList.add('show');
    discountedPlanElement.innerText = discountText;
  }

  const url = new URL(window.location.href);
  const revealPopup = url.searchParams.get(SELECTORS.revealPopup) === SELECTORS.revealValue;

  if (modal && (revealPopup === true || discountText)) {
    setTimeout(() => {
      document.querySelector(SELECTORS.discountInfo).classList.add(SELECTORS.discountInfoActive);
      container.classList.remove(SELECTORS.hidden);
      container.classList.add(SELECTORS.show);
    }, timeout);
  }
})
